export interface HaiLuoNativeBridgeMeta {
  callNative: (params: string) => void;
  onCallNativeResult: (params: string) => void;
}

interface CallNativeParams {
  methodName: string;
  params?: any;
  callbackId?: string;
}

interface CallNativeResultParams {
  callbackId: string;
  params?: {
    statusCode: number;
    errMsg?: string;
    data?: any;
  };
}

// 前端调用客户端
const callNativeBridge = () => {
  const hasNativeBridge = () => {
    if (!window.hailuoNativeBridge) return false;
    if (!window.hailuoNativeBridge?.callNative) return false;
    if (!window.hailuoNativeBridge?.onCallNativeResult) return false;
    return true;
  };

  // 基础API调用
  const callNative = (params: CallNativeParams) => {
    if (!hasNativeBridge() || !params.methodName) {
      // todo 异常处理
      return;
    }
    const paramsToString = JSON.stringify(params);
    window.hailuoNativeBridge?.callNative(paramsToString);
  };

  // 回调方法
  const onCallNativeResult = (params: CallNativeResultParams) => {
    if (!hasNativeBridge() || !params.callbackId) {
      // todo 异常处理
      return;
    }
    const paramsToString = JSON.stringify(params);
    window.hailuoNativeBridge?.onCallNativeResult(paramsToString);
  };

  return {
    callNative: callNative,
    onCallNativeResult: onCallNativeResult,
  };
};

export const nativeBridge = callNativeBridge();
